//@ts-ignore
const ua = navigator.userAgent || navigator.vendor || window.opera;
const isFacebook = ua.match(/FBAN|FBAV/i);
const isInstagram = ua.indexOf("Instagram") > -1 ? true : false;
export const isWebview = isFacebook || isInstagram;
